import { render, staticRenderFns } from "./TrustflixHeader.vue?vue&type=template&id=70c638f3&scoped=true"
import script from "./TrustflixHeader.vue?vue&type=script&lang=js"
export * from "./TrustflixHeader.vue?vue&type=script&lang=js"
import style0 from "./TrustflixHeader.vue?vue&type=style&index=0&id=70c638f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c638f3",
  null
  
)

export default component.exports